import { formatDateTime, formatAction } from "@/utils/formatters";

export function ActivitySection({ activities }) {
  return (
    <>
      {activities.length === 0 && <p className="text-sm text-[#52525B] py-4 text-center" data-testid="no-activity">No activity yet</p>}
      <div className="space-y-0 divide-y divide-[#E4E4E7]" data-testid="activity-list">
        {activities.map((a) => (
          <div key={a.id} className="py-2.5 flex items-start gap-2 text-sm" data-testid={`activity-${a.id}`}>
            <div className="w-1.5 h-1.5 rounded-full bg-[#003DA5] mt-1.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <span className="font-medium text-[#09090B]">{a.user_name}</span>{" "}<span className="text-[#52525B]">{formatAction(a)}</span>
              <p className="text-xs text-[#52525B] mt-0.5">{formatDateTime(a.created_at)}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
